/*
 * Photo Headshot design presets — ported 1:1 from the DecKorate POC's
 * `AIDesigner.PHOTO_HEAD_DESIGNS` (src/taskpane/aiDesigner.js). Six plain
 * photo shapes (circle/rounded-rectangle, varying border+shadow) and four
 * "bio card" templates that add name/title/detail text next to the photo.
 */

import type { PhotoHeadDesign } from "../../../types";

export const PHOTO_HEAD_DESIGNS: readonly PhotoHeadDesign[] = [
  // Photo-only designs
  { id: "circle-blue", label: "Circle — Blue", shape: "OVAL", borderColor: "0078D4", borderWidth: 2, shadow: false, template: null },
  { id: "circle-white", label: "Circle — White", shape: "OVAL", borderColor: "FFFFFF", borderWidth: 3, shadow: true, template: null },
  { id: "circle-dark", label: "Circle — Dark", shape: "OVAL", borderColor: "2B2B2B", borderWidth: 2, shadow: false, template: null },
  { id: "circle-gold", label: "Circle — Gold", shape: "OVAL", borderColor: "D4A017", borderWidth: 2.5, shadow: false, template: null },
  { id: "circle-noborder", label: "Circle — Clean", shape: "OVAL", borderColor: null, borderWidth: 0, shadow: true, template: null },
  { id: "roundrect-blue", label: "Rounded — Blue", shape: "ROUNDED_RECTANGLE", borderColor: "0078D4", borderWidth: 2, shadow: false, template: null },

  // Bio card templates (photo + name + title + details)
  {
    id: "bio-card-left", label: "Bio Card — Left", shape: "OVAL", borderColor: "0078D4", borderWidth: 2, shadow: false,
    template: {
      layout: "left", photoSize: 1.5, cardWidth: 4.5, cardHeight: 2.0, cardBg: "F3F2F1", cardRadius: 8,
      fields: [
        { key: "name", default: "Full Name", fontSize: 14, bold: true, color: "323130" },
        { key: "title", default: "Job Title", fontSize: 11, bold: false, color: "605E5C" },
        { key: "detail", default: "Department / Location", fontSize: 9, bold: false, color: "A19F9D" },
      ],
    },
  },
  {
    id: "bio-card-top", label: "Bio Card — Top", shape: "OVAL", borderColor: "FFFFFF", borderWidth: 2, shadow: true,
    template: {
      layout: "top", photoSize: 1.5, cardWidth: 2.8, cardHeight: 3.0, cardBg: "FFFFFF", cardRadius: 8,
      fields: [
        { key: "name", default: "Full Name", fontSize: 13, bold: true, color: "323130" },
        { key: "title", default: "Job Title", fontSize: 10, bold: false, color: "605E5C" },
        { key: "detail", default: "email@company.com", fontSize: 9, bold: false, color: "0078D4" },
      ],
    },
  },
  {
    id: "bio-strip", label: "Bio Strip — Wide", shape: "OVAL", borderColor: "2B2B2B", borderWidth: 1.5, shadow: false,
    template: {
      layout: "left", photoSize: 1.2, cardWidth: 4.0, cardHeight: 1.4, cardBg: "2B2B2B", cardRadius: 4, darkMode: true,
      fields: [
        { key: "name", default: "Full Name", fontSize: 12, bold: true, color: "FFFFFF" },
        { key: "title", default: "Job Title | Department", fontSize: 10, bold: false, color: "A19F9D" },
      ],
    },
  },
  {
    id: "bio-card-accent", label: "Bio Card — Accent", shape: "OVAL", borderColor: "FFFFFF", borderWidth: 2.5, shadow: true,
    template: {
      layout: "top", photoSize: 1.4, cardWidth: 3.0, cardHeight: 2.8, cardBg: "0078D4", cardRadius: 10, darkMode: true, accentBar: true,
      fields: [
        { key: "name", default: "Full Name", fontSize: 14, bold: true, color: "FFFFFF" },
        { key: "title", default: "Job Title", fontSize: 10, bold: false, color: "D6E4F0" },
        { key: "detail", default: "Company Name", fontSize: 9, bold: false, color: "B4D6F5" },
      ],
    },
  },
];

export function getPhotoHeadDesign(id: string): PhotoHeadDesign | undefined {
  return PHOTO_HEAD_DESIGNS.find((design) => design.id === id);
}
